/** AutoDay's canonical mark; adjacent wordmark supplies its accessible name. */
export function BrandMark({ size = 32 }: { size?: number }) {
  return <img src="/brand/autoday.svg" width={size} height={size} alt="" aria-hidden="true" className="shrink-0" decoding="async" />;
}
